export default __webpack_public_path__ + "static/media/paused-with-bg.6727e613.svg";